interface CacheEntry<T> {
  data: T;
  expiresAt: number; // 0 = never expires
}

class SimpleCache {
  private store = new Map<string, CacheEntry<unknown>>();

  get<T>(key: string): T | null {
    const entry = this.store.get(key);
    if (!entry) return null;
    if (entry.expiresAt !== 0 && Date.now() > entry.expiresAt) {
      this.store.delete(key);
      return null;
    }
    return entry.data as T;
  }

  set<T>(key: string, data: T, ttlMs = 0): void {
    this.store.set(key, {
      data,
      expiresAt: ttlMs === 0 ? 0 : Date.now() + ttlMs,
    });
  }

  delete(key: string): void {
    this.store.delete(key);
  }
}

export const apiCache = new SimpleCache();

export const TTL = {
  FOREVER: 0,
  FIVE_MIN: 5 * 60 * 1000,
  TWO_MIN: 2 * 60 * 1000,
} as const;
